export default "__VITE_ASSET__BIm58VKB__"